import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BenefitValue  {
    _originalTypeClassName = "zERP.BO.BenefitValue";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BenefitValue.translate = translateService;
}
this.Id = null;
this.Name = null;
this.Description = null;
this.DataType = null;
this.bValue = false;
this.nValue = null;
this.fValue = null;
this.dtValue = null;
this.strValue = null;
this.IsHidden = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Description:any;
DataType:any;
bValue:any;
nValue:any;
fValue:any;
dtValue:any;
strValue:any;
IsHidden:any;
ForeignAttributeValues:any;
static setForeignAttributeValues = ($this, value) => {
var oldValue = $this.ForeignAttributeValues;
$this.ForeignAttributeValues = value;
if (value != null) {
}
}

static createBenefitForeignAttribute(source: any): any{let bv = new Domain.BenefitValue();
Domain.BenefitValue.setForeignAttributeValues(bv, new Domain.ForeignAttributeValues());
if (source?.clsAttributeEnumValue?.ForeignAttribute?.AttributeName != null) {bv.ForeignAttributeValues.AttributeName = source?.clsAttributeEnumValue?.ForeignAttribute?.AttributeName;}
if (source?.clsAttributeEnumValue?.ForeignAttribute?.GroupName?.Description != null) {bv.ForeignAttributeValues.GroupDisplay = source?.clsAttributeEnumValue?.ForeignAttribute?.GroupName?.Description;}
bv.ForeignAttributeValues.AttributeId = source?.Id;
bv.DataType = source?.clsAttributeEnumValue?.ForeignAttribute?.DataType;
return bv;
}
static createBenefitValue(source: any): any{let bv = new Domain.BenefitValue();
bv.Name = source?.Name;
bv.Description = source?.Description;
bv.DataType = source?.DataType;
bv.bValue = (source?.DataType == Domain.DataType.Logic ? source?.clsAttributeEnumValue?.bValue : false);
bv.nValue = ((source?.DataType == Domain.DataType.Integer || source?.DataType == Domain.DataType.Duration) ? CLMS.Framework.Integer.Parse(source?.clsAttributeEnumValue?.strValue) : null);
bv.fValue = ((source?.DataType == Domain.DataType.Numeric || source?.DataType == Domain.DataType.Money) ? CLMS.Framework.Double.Parse(source?.clsAttributeEnumValue?.strValue) : null);
bv.dtValue = ((source?.DataType == Domain.DataType.DateTime || source?.DataType == Domain.DataType.Date || source?.DataType == Domain.DataType.Time) ? source?.clsAttributeEnumValue?.dtValue : null);
bv.strValue = ((source?.DataType == Domain.DataType.Entity || source?.DataType == Domain.DataType.ListValue || source?.DataType == Domain.DataType.String) ? source?.clsAttributeEnumValue?.strValue : null);
return bv;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}